// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1671":"ab49ec9c2393b184","3273":"cd038b4f662f38c1"}[chunkId] + ".css";
};